import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import fetch from "@lib/fetch";

import { cacheKey } from "./constants";
import type { WhatsAppMessagingService } from "./types";

export const getWhatsAppMessagingServices = reactQueryFetcherAdapter(
  cacheKey,
  (signal, { query, limit }: { query: string; limit: number }) => {
    return fetch<WhatsAppMessagingService[]>(
      `/engagement/whatsapp/messaging_services`,
      "GET",
      {
        query,
        limit,
      },
      { signal }
    );
  }
);
